import { Link } from 'react-router-dom';
import LegalPage from './LegalPage';
import { SUPPORT_EMAIL } from '../utils/constants';

const Privacy = () => {
  return (
    <LegalPage title="Privacy Policy" updated="June 11, 2026">
      <p>
        Solidly makes SolidlyAI Agents, a desktop app sold on this website (agents.solidly.ai).
        The product is local-first by design: your agents, conversations, schedules, and meeting
        transcripts live in a local database on your machine, not on our servers. This page
        explains, in plain English, what data we do touch — on this website and in the app — and
        what we never see.
      </p>

      <h2>What this website collects</h2>
      <ul>
        <li>
          <strong>Analytics.</strong> We use Google Analytics 4 to understand how visitors use
          this site (pages viewed, buttons clicked, rough location and device type). Google sets
          cookies to do this. We don't use the data for advertising, and we don't sell it.
        </li>
        <li>
          <strong>Payments.</strong> Checkout is handled entirely by Stripe. Your card details
          go to Stripe, not to Solidly — we never see or store your payment information. After a
          purchase, we receive your email address and a record of the purchase so we can send
          your license key and honor refunds.
        </li>
      </ul>

      <h2>What we store to run your license</h2>
      <ul>
        <li>
          When you buy, we store your email address and license key in our database (AWS
          DynamoDB), and send your license key to you by email (via AWS SES).
        </li>
        <li>
          When you activate the app, we store an identifier for that device alongside your
          license, so we can enforce the 3-device activation limit. That's the extent of what
          license activation sends us.
        </li>
      </ul>

      <h2>What the app collects</h2>
      <ul>
        <li>
          <strong>By default: nothing leaves your machine.</strong> Your workspace — agents,
          schedules, conversations, meeting transcripts — is stored in a local SQLite database
          on your device. We have no access to it.
        </li>
        <li>
          <strong>Your own provider keys.</strong> Agents run on your Claude subscription, and
          meeting transcription runs on your own transcription provider key. Those requests go
          directly from your machine to your providers under their terms — not through Solidly.
        </li>
        <li>
          <strong>Solidly Sync (optional, $5/mo).</strong> If you enable the Sync add-on, the
          app uploads encrypted snapshots of your local database to our storage (AWS S3), keyed
          off your license. Snapshots are encrypted before they leave your machine. If you never
          enable Sync, nothing is ever uploaded.
        </li>
      </ul>

      <h2>What we don't do</h2>
      <ul>
        <li>We don't sell or share your data with third parties for marketing.</li>
        <li>We don't read your workspace, transcripts, or agent output.</li>
        <li>We don't resell or proxy your Claude or transcription usage.</li>
      </ul>

      <h2>Refunds</h2>
      <p>
        Every purchase comes with a 7-day money-back guarantee — email{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> within 7 days for a full refund.
        See the <Link to="/terms">Terms</Link> for details.
      </p>

      <h2>Questions</h2>
      <p>
        Anything unclear, or want your data deleted? Email{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> and a human will answer.
      </p>
    </LegalPage>
  );
};

export default Privacy;
